// GlobalDataContext.jsx
import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api';

const GlobalDataContext = createContext(null);

export const GlobalDataProvider = ({ children }) => {
  const [websiteDetails, setWebsiteDetails] = useState();
  const [loading , setLoading] = useState(true);

 useEffect(() => {
    const fetchWebsiteDetails = async () => {
      try {
        const web = await api.getWebsiteDetails();
        setWebsiteDetails(web);
      } catch (err) {
        console.error("Failed to load website details", err);
      } finally {
        setLoading(false);
      }
    };
    fetchWebsiteDetails();
  }, []); 

  return (
    <GlobalDataContext.Provider
      value={{
        websiteDetails,
        loading,
      }}
    >
      {children}
    </GlobalDataContext.Provider>
  );
};

export const useGlobalData = () => {
  const context = useContext(GlobalDataContext);
  if (!context) {
    throw new Error('useGlobalData must be used within a GlobalDataProvider');
  }
  return context;
};